<template>
  <el-dialog
    id="app"
    v-el-drag-dialog
    v-loading="printLoading"
    :element-loading-text="printLoadingText"
    no="dialog"
    :visible.sync="isShowDialog"
    :title="$t('Template.WinName')"
    width="600px"
    :close-on-click-modal="false"
    append-to-body
    class="app-main-inner"
    @close="close"
  >
    <el-row :gutter="10">
      <el-col :span="12">
        <el-input ref="searchInput" v-model.trim="filterText" no="1" clearable :placeholder="$t('Message.pleaseEnterTemplateName')" @input="handleFilter" />
      </el-col>
    </el-row>
    <div style="padding:0">
      <el-checkbox v-model="isEmailModel" no="2" @change="() => toFilterRows(1)">{{ $t('Template.EmailTemp') }}</el-checkbox>
      <el-checkbox v-model="isV3Model" no="3" @change="() => toFilterRows(1)">{{ $t('Template.viewV3') }}</el-checkbox>
    </div>
    <div class="app-main-inner-row row-grid" style="padding: 5px 0;">
      <cargo-ag-grid
        no="gird"
        :show-side-bar="false"
        :grid-options="gridOptions"
        :column-defs="columnDefs"
        :row-data="rowData"
        :auto-fit-content="false"
        style="width: 100%;height: 350px"
        @gridReady="onGridReady"
      />
    </div>
    <span slot="footer">
      <el-button
        v-if="!callByInstruction"
        :disabled="!template||template.engine===0"
        no="Copy"
        type="primary"
        style="float:left;"
        @click="showCopyDialog"
      >{{ $t('Template.Copy') }}</el-button>
      <el-button v-show="template && template.engine === 2 && v3MailSend === 1" style="float:left;" no="4" type="primary" @click="sendMail">{{ $t('SeaExport.SendEMail') }}</el-button>
      <template v-if="template && template.engine === 2">
        <el-button no="ExportPDF" type="primary" style="float:left;" @click="exportReport('ExportPDF')">{{ $t('Message.ExportPDF') }}</el-button>
        <el-button no="ExportExcel2" type="primary" style="float:left;" @click="exportReport('ExportXLS')">{{ $t('Message.ExportExcel2') }}</el-button>
        <el-button no="ExportWord" type="primary" style="float:left;" @click="exportReport('ExportWORD')">{{ $t('Message.ExportWord') }}</el-button>
        <el-button no="ExportPPT" type="primary" style="float:left;" @click="exportReport('ExportPPT')">{{ $t('Message.ExportPPT') }}</el-button>
      </template>
      <el-button no="5" type="primary" @click="toPrint()">{{ $t('common.btn.ok') }}</el-button>
      <el-button no="6" @click="close">{{ $t('common.btn.cancel') }}</el-button>
    </span>
    <!-- 用于打开新页面，并以post方式提交 -->
    <form ref="form" :action="url" target="_blank" method="post" style="display:none">
      <input v-for="item in formEntries" :key="item[0]" no="10" :name="item[0]" :value="item[1]">
    </form>
    <!-- 复制弹窗 -->
    <el-dialog
      v-el-drag-dialog
      no="copyDialog"
      :visible.sync="copyDialog.visible"
      :title="$t('Template.inputTemplateName')"
      width="400px"
      :close-on-click-modal="false"
      class="app-main-inner"
      append-to-body
    >
      <el-form label-width="70px" label-position="left">
        <el-form-item :label="$t('Template.TemplateName')">
          <el-input v-model="copyDialog.name" no="7" />
        </el-form-item>
      </el-form>
      <span slot="footer" style="padding-right:30px">
        <el-button type="primary" no="8" @click="save">{{ $t('common.btn.ok') }}</el-button>
        <el-button no="9" @click="copyDialog.visible=false">{{ $t('common.btn.cancel') }}</el-button>
      </span>
    </el-dialog>

    <!-- 预览弹窗 -->
    <!-- @updateDocCfmStateFunc="updateDocCfmStateFunc" -->
    <cargo-template-preview
      no="cargoTemplatePreview"
      :visible.sync="cargoTemplatePreview.visible"
      :template="cargoTemplatePreview.template || {}"
      :fetch-size="cargoTemplatePreview.fetchSize || 0"
      :parameters="cargoTemplatePreview.parameters || {}"
      :entity="cargoTemplatePreview.entity || {}"
      :context="context || {}"
      :job-uuid-list="jobUuidList"
      @sendEmailTriggerEvent="sendEmailTriggerEventHandler"
      @printTempFileEvent="printTempFileEventHandler"
      @sopTriggerEvent="sopTriggerEventHandler"
      @returnMainEvent="returnMainEventHandler"
    />

    <!-- 发送邮件弹窗 -->
    <send-email-dialog
      v-if="sendEmailDialog.visible"
      no="sendEmailDialog"
      :visible.sync="sendEmailDialog.visible"
      :append-to-body="appendToBody"
      :context="context"
      :push-link="SystemConstants.SE_BATCH_PRINT"
      :job="finalCtx"
      :job-uuid-list="jobUuidList"
      :send-email-data="sendEmailDialog"
      :send-call-back="sendCallBackEvent"
      :source="source"
      :v3mail="finalData.V3mail"
      @sendMailPreview="toPrint"
    />
    <!-- 打印记录数超过系统上限弹窗 -->
    <el-dialog
      v-if="overLimitDialog.visible"
      v-el-drag-dialog
      no="overLimitDialog"
      :visible.sync="overLimitDialog.visible"
      :title="$t('Message.Prompt')"
      width="400px"
      :close-on-click-modal="false"
      class="app-main-inner"
      append-to-body
    >
      <div style="text-align: center;padding: 10px 0px;font-size: 14px;">{{ $t('Message.PrintRecordsOverLimitTip') }}</div>
      <div slot="footer" style="margin: 0 auto;width: fit-content;">
        <el-button no="exportPdf2" type="primary" @click="exportReport('ExportPDF');overLimitDialog.visible=false">{{ $t('Message.ExportPDF') }}</el-button>
        <el-button no="exportExcel2" type="primary" @click="exportReport('ExportXLS');overLimitDialog.visible=false">{{ $t('Message.ExportExcel2') }}</el-button>
        <el-button no="exportWord2" type="primary" @click="exportReport('ExportWORD');overLimitDialog.visible=false">{{ $t('Message.ExportWord') }}</el-button>
        <el-button no="ExportPPT2" type="primary" @click="exportReport('ExportPPT');overLimitDialog.visible=false">{{ $t('Message.ExportPPT') }}</el-button>
        <el-button no="cancel2" @click="overLimitDialog.visible=false">{{ $t('CargoMsg.Cargo_Cancel') }}</el-button>
      </div>
    </el-dialog>
    <!-- 打印记录数超过100条弹窗 -->
    <el-dialog
      v-if="over100Dialog.visible"
      v-el-drag-dialog
      no="over100Dialog"
      :visible.sync="over100Dialog.visible"
      :title="$t('Message.Prompt')"
      width="400px"
      :close-on-click-modal="false"
      class="app-main-inner"
      append-to-body
      :before-close="over100Dialog.beforeClose"
    >
      <div style="text-align: center;padding: 10px 0px;font-size: 14px;">{{ $t('Message.PrintRecordsOver100Tip') }}</div>
      <div slot="footer" style="margin: 0 auto;width: fit-content;">
        <el-button no="exportPdf3" type="primary" @click="over100Dialog.exportPdf">{{ $t('Message.ExportPDF') }}</el-button>
        <el-button no="exportExcel3" type="primary" @click="over100Dialog.exportExcel">{{ $t('Message.ExportExcel2') }}</el-button>
        <el-button no="exportWord3" type="primary" @click="over100Dialog.exportWord">{{ $t('Message.ExportWord') }}</el-button>
        <el-button no="ExportPPT3" type="primary" @click="over100Dialog.exportPPT">{{ $t('Message.ExportPPT') }}</el-button>
        <el-button no="continue3" @click="over100Dialog.continue">{{ $t('Message.ContinuePreview') }}</el-button>
      </div>
    </el-dialog>
  </el-dialog>
</template>

<script>

import { cacheName, cache } from '@/utils/cacheManager'
import { Job } from '@/class/model/booking/Job'
import {
  getTemplateList,
  saveTemplate,
  getTemplateName,
  updateDocCfmState,
  queryByFileTypeOrTemplateUuids
} from '@/api/sysManage/baseConfig/template'
import { getTemplateTypeList } from '@/api/sysManage/baseConfig/templateType'
import { getDocumentType } from '@/api/documentType'
import { checkTemplateExist } from '@/api/report'
import { refreshPrintStatus, updateTrackingForDocumentType } from '@/api/fileHistory'
import { saveMetaData } from '@/api/storage'
import { StimulSoftUtil } from '@/class/cargo/model/utils/StimulSoftUtil'
import { PrintTaskV2RequestBuilder } from '@/class/cargo/model/print/PrintTaskV2RequestBuilder'
import { getPrintTaskClientModeValue } from '@/utils/printTaskMode'
import { PrintTemplateManager } from '@/class/cargo/model/utils/PrintTemplateManager'
import { PrintUtils } from '@/utils/PrintUtils'
import { isString } from '@/utils/validate'
import cargoTemplatePreview from '@/components/Cargo/Common/cargoTemplatePreview'
import sendEmailDialog from '@/components/Cargo/Job/sendEmailDialog'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import lang from '@/lang'
import { sortByMultiField } from '@/utils'
import lodash from 'lodash'
import { SeaCargoDoc } from '@/class/model/booking/SeaCargoDoc'
import { SeaImCargoDoc } from '@/class/model/booking/SeaImCargoDoc'
import { getLoading4Cxt } from '@/utils/utilBaseElement'
import { SeaExportJob } from '@/class/model/booking/SeaExportJob'
import {
  AE,
  AI,
  IE,
  INSTRUCTION_BATCH_TEMPLATE_TYPE_MAP,
  INSTRUCTION_TEMPLATE_TYPE_MAP,
  RE,
  RI,
  SE,
  SI, TEMPLATE_TYPE_AEBOOKING, TEMPLATE_TYPE_AEHAWB, TEMPLATE_TYPE_AEMAWB, TEMPLATE_TYPE_AIHAWB, TEMPLATE_TYPE_AIJOBNO,
  TEMPLATE_TYPE_BACNKLETTER,
  TEMPLATE_TYPE_BOOKING, TEMPLATE_TYPE_BOOKING_RE,
  TEMPLATE_TYPE_FBA_INTERNAL_WAREHOUSE,
  TEMPLATE_TYPE_FBA_OVERSEA_WAREHOUSE,
  TEMPLATE_TYPE_LOCALSERVICE,
  TEMPLATE_TYPE_MANIFESTINFO,
  TEMPLATE_TYPE_POD_TRUCKING,
  TEMPLATE_TYPE_SIHBL,
  TEMPLATE_TYPE_SIJOBNO,
  TEMPLATE_TYPE_SIMBL, TEMPLATE_TYPE_SIPO
} from '@/class/cargo/model/parameters/SystemConstants'
import { Company } from '@/class/model/mdm/Company'
import { Customer } from '@/class/model/mdm/Customer'
import * as ContainerLoadType from '@/class/cargo/model/parameters/ContainerLoadType'
import { loadWarehouseInRelated } from '@/api/warehouseIn/warehouseIn'
import { getDischargingTruckingList } from '@/api/seaExport/dischargingTrucking'
import StrUtils from '@/utils/StrUtils'
import { SeaImportJob } from '@/class/model/booking/SeaImportJob'
import { updateTrackingEvent } from '@/api/trackingService'
import * as CargoDocConsts from '@/class/cargo/model/parameters/CargoDocConsts'
import * as DocumentConstants from '@/class/cargo/model/parameters/DocumentConstants'
import { AirExportJob } from '@/class/model/booking/AirExportJob'
import { AirImportJob } from '@/class/model/booking/AirImportJob'
import { RailwayExportJob } from '@/class/model/booking/RailwayExportJob'
import { IntegratedJob } from '@/class/model/booking/IntegratedJob'
import { PrintTemplateUtil } from '@/class/cargo/model/utils/PrintTemplateUtil'

export default {
  name: 'CargoTemplateSelectDialog',
  components: { cargoTemplatePreview, sendEmailDialog },
  props: {
    visible: { type: Boolean, required: true },
    ctx: { type: Object, default: null }, // 相当于老系统的 entity
    category: { type: String, default: '' },
    data: { type: Object, required: true },
    context: { type: Object, default: null },
    jobUuidList: { type: Array, default: null },
    printChannel: { type: Number, default: 0 }, // 打印渠道 1 OCR识别
    prePrintCallback: { type: Function, default: null },
    printedCallback: { type: Function, default: null },
    v2CheckCallback: { type: Function, default: null },
    returnMainCallback: { type: Function, default: null }, // V1返回主页面按钮回调事件
    callByInstruction: { type: Boolean, required: false }, // 通过指令调用
    templateUuids: { type: Array, default: () => [] }, // 模板uuids
    documentTypeUuid: { type: String, default: '' }, // 模板uuids
    lob: { type: String, default: '' }, // 业务类型
    job: { type: Object, default: null } // 业务
  },
  data() {
    return {
      SystemConstants,
      filterText: '',
      innerVisible: false,
      isShowDialog: false,
      printLoading: false,
      printLoadingText: '',
      appendToBody: true,
      user: {},
      officeId: 0,
      source: '4', // 发送邮件模板id，海出批量
      previewType: '',
      isEmailModel: false,
      isV3Model: false,
      v3MailSend: 0,
      v3PrintCount: 0,
      designMode: 0,
      selectedLength: 0,
      isPreCommit: false, // 预提交状态，预提交的参数带到这里，再由回调函数返回去
      gridOptions: {
        rowSelection: 'single',
        suppressCellSelection: true,
        suppressRowClickSelection: false,
        onRowDoubleClicked: (event) => {
          this.toPrint()
        },
        onRowClicked: this.onRowClick,
        context: {
          componentParent: this
        }
      },
      columnDefs: [
        {
          headerName: this.$t('Template.TemplateName'),
          colId: 'name',
          field: 'name',
          suppressMenu: true,
          width: 200
        }, {
          headerName: this.$t('Template.TemplateTypes'),
          colId: 'engineStr',
          field: 'engineStr',
          suppressMenu: true,
          getQuickFilterText: (params) => {
            return params.data.name
          },
          width: 100
        }
      ],
      rawData: [],
      rowData: [],
      gridApi: null,
      template: null,
      templateType: null,
      documentType: null,
      url: '',
      formEntries: [],
      copyDialog: {
        visible: false,
        name: ''
      },
      cargoTemplatePreview: {
        visible: false,
        template: {},
        fetchSize: 3,
        parameters: {},
        entity: {}
      },
      // V2V3模板直发邮件能根据接收方类型自动取邮件地址
      enableEmailAddressByReceiver: false,
      enabledReportVersionSelection: 0,
      email_to: '',
      email_cc: '',
      email_title: '',
      email_content: '',
      action: null, // V1打印模板抽取参数
      format: null, // V1打印模板抽取参数
      sendEmailDialog: { // 发送邮件所需
        visible: false,
        emailTitle: '',
        emailContent: '',
        detailCode: '',
        fileIdList: ''
      },
      overLimitDialog: {
        visible: false
      },
      over100Dialog: {
        visible: false,
        beforeClose: () => {},
        exportPdf: () => {},
        exportExcel: () => {},
        continue: () => {}
      },
      instructionData: {
        ctx: new Job(),
        data: {},
        printedCallback: null,
        category: null
      }
    }
  },
  computed: {
    cargoTemplatePreviewVisible() {
      return this.cargoTemplatePreview.visible
    },
    exportType() {
      if (this.previewType === 'ExportPDF' || this.previewType === 'ExportXLS' || this.previewType === 'ExportWORD' || this.previewType === 'ExportPPT') {
        return this.previewType
      }
      return ''
    },
    finalCtx() {
      return this.callByInstruction ? this.instructionData.ctx : this.ctx
    },
    finalData() {
      return this.callByInstruction ? this.instructionData.data : this.data
    },
    finalPrintedCallback() {
      return this.callByInstruction ? this.instructionData.printedCallback : this.printedCallback
    },
    finalCategory() {
      return this.callByInstruction ? this.instructionData.category.trimEnd() : this.category
    }
  },
  watch: {
    visible: {
      async handler(newVal) {
        this.innerVisible = newVal
        if (newVal) {
          await this.preloadBasicData()
          this.initData() // newVal 为true 时在 initData处理，根据是否有模板来判断是否显示弹框
        }
      },
      immediate: true
    },
    innerVisible(newVal) {
      if (!newVal && this.gridApi) {
        this.gridApi.setRowData([])
        this.gridApi.clearFocusedCell()
        this.isShowDialog = false
      }
      this.$emit('update:visible', newVal)
    },
    cargoTemplatePreviewVisible(newVal) {
      if (!newVal) {
        this.innerVisible = false
      }
    }
  },
  async created() {},
  methods: {
    // v3发送邮件
    sendMail() {
      this.sendEmailDialog.visible = true
    },
    async preloadBasicData() {
      await cache.load(cacheName.USER, cacheName.OFFICE, cacheName.CONFIG)
      this.v3MailSend = Number(cache.config.get('v3MailSend'))
      this.user = cache.user
      this.officeId = cache.office.officeId
      this.isV3Model = Number(cache.config.get('IsV3Model')) === 1
      this.v3PrintCount = Number(cache.config.get('printCount'))
      this.designMode = this.$checkPermission(['role_template_design']) ? 1 : 0
      this.enabledReportVersionSelection = Number(cache.config.get('EnabledReportVersionSelection'))
      this.enableEmailAddressByReceiver = Number(cache.config.get('enableEmailAddressByReceiver')) === 1
      if (this.finalCtx) {
        // 信控验证
        if (this.finalCtx instanceof Job) {
          const job = this.finalCtx
          if (Number(cache.config.get('creditOpen')) === 1) {
            const blocks = this.getCreditTemplateSetting(job.lob)
            if (job.blocked && typeof blocks[this.finalCategory] !== 'undefined' && Number(blocks[this.finalCategory]) === 1) {
              this.$message.warning(lang.t('Message.PleaseContactTheSuperiorUnlocked'))
              return
            }
          }
        }
        this.finalData.uuid = this.finalCtx.uuid || ''
        this.finalData.classNameType = Object.prototype.hasOwnProperty.call(this.finalData, 'classNameType') && this.finalData.classNameType ? this.finalData.classNameType : SystemConstants.BOOKING
        // this.finalData.className = this.finalCtx.constructor.name // 服务器取出来的值不对，故在对应的前端类里面加类命，请参考 SeaExportJob.js
        // console.log('==this.finalCtx==', this.finalCtx)
        this.finalData.className = this.finalCtx.className || this.finalCtx.constructor.name
        // console.log('==this.finalCtx.constructor==', this.finalCtx.constructor.name)
        // console.log('==className==', this.finalData.className)
      }
      if (!this.finalData.JOB_UUID && this.finalData.jobuuid) {
        this.finalData.JOB_UUID = this.finalData.jobuuid
        this.finalData.jobuuid = this.finalData.jobuuid
      }
      this.isPreCommit = typeof this.finalData.isPreCommit === 'undefined' ? true : Boolean(this.finalData.isPreCommit)
      this.finalData.showPreview = typeof this.finalData.showPreview === 'undefined' ? true : Boolean(this.finalData.showPreview)
      this.finalData.printType = 'PRINT'
      this.finalData.createBy = this.user.userId
      for (const key in this.finalData) {
        if (key === 'printCallBackUrl') {
          continue
        }
        const item = this.finalData[key]
        if (Array.isArray(item)) {
          this.selectedLength = item.length
          break
        }
      }
    },
    onGridReady(params) {
      this.gridApi = params.api
      this.gridApi.sizeColumnsToFit()
      if (this.callByInstruction) {
        // 只有一条数据，默认选中第一条
        if (this.rawData && this.rawData.length === 1) {
          this.$nextTick(() => {
            const nodes = this.gridApi.getRenderedNodes()
            // 默认选中第一个
            for (const item of nodes) {
              item.setSelected(true)
              this.template = item.data
              this.onRowClick(item)
              break
            }
          })
        }
      }
    },
    async onRowClick(event) {
      this.template = event.data
      if (this.callByInstruction) {
        this.instructionData.category = this.template.templateType
        // 通过指令调用打印时，需要在此构建ctx、data
        await this.buildCtxAndData()
      }
    },
    async initData() {
      let params
      let getTemplatesFunc
      if (this.callByInstruction) {
        params = {
          officeId: this.officeId,
          templateTypes: this.jobUuidList && this.jobUuidList.length > 0 ? [INSTRUCTION_BATCH_TEMPLATE_TYPE_MAP.get(this.lob)] : INSTRUCTION_TEMPLATE_TYPE_MAP.get(this.lob),
          templateUuids: this.templateUuids,
          documentTypeUuid: this.documentTypeUuid,
          ctx: this.job ? this.job.uuid : '',
          lob: this.lob
        }
        getTemplatesFunc = queryByFileTypeOrTemplateUuids
      } else {
        // pillBranchId：传入的分公司ID
        params = { templateType: this.finalCategory, officeId: this.finalData.pillBranchId || this.officeId }
        // 成基清关页签打印使用-特殊处理【成基这边需要根据权限来过滤要显示的模板】
        const templateTypes = []
        if (this.finalCategory === 'US_CLEAR_CUSTOMS') {
          // 导出7501模板
          if (this.$checkPermission(['button_UsCustomsClearance_export7501'])) {
            templateTypes.push('US_CLEAR_CUSTOMS_7501')
          }
          // 导出发票箱单模板
          if (this.$checkPermission(['button_UsCustomsClearance_exportInvoiceList'])) {
            templateTypes.push('US_CLEAR_CUSTOMS_INVOICE')
          }
          if (templateTypes.length > 0) {
            delete params.templateType
            params.templateTypes = templateTypes
          }
        }
        // 过滤打印渠道
        if (this.printChannel !== 0) {
          params.printChannel = this.printChannel
        }
        if (this.finalCtx) {
          params.ctx = this.finalCtx.uuid
          params.className = this.finalCtx.className || this.finalCtx.constructor.name
          if (params.className === 'Object' && this.finalCtx.lob != null) {
            switch (this.finalCtx.lob) {
              case 'SE':
                params.className = 'SeaExportJob'
                break
              case 'SI':
                params.className = 'SeaImportJob'
                break
              case 'AE':
                params.className = 'AirExportJob'
                break
              case 'AI':
                params.className = 'AirImportJob'
                break
              case 'RE':
              case 'RI':
                params.className = 'RailwayExportJob'
                break
            }
          }
          params.classNameType = Object.prototype.hasOwnProperty.call(this.finalData, 'classNameType') && this.finalData.classNameType ? this.finalData.classNameType : SystemConstants.BOOKING
        }
        getTemplatesFunc = getTemplateList
      }
      // this.$logger.log('--params--', params)
      return await getTemplatesFunc(params).then(res => {
        this.rawData = []
        const result = res.data
        if (result && result.length > 0) {
          // 先根据officeId降序
          const sortResult = sortByMultiField(result, ['officeId'], true)
          // 再根据name升序
          const finalResult = (sortResult && sortResult.length > 0) ? sortByMultiField(sortResult, ['name'], false) : []
          // this.$logger.log('finalResult===', finalResult)
          const keys = []
          if (finalResult && finalResult.length > 0) {
            for (const item of finalResult) {
              const templateKey = item.name + '@' + item.templateType
              if (keys.includes(templateKey)) {
                continue
              }
              keys.push(templateKey)
              item.engineStr = item.engine === 0 ? 'V1' : (item.engine === 1 ? 'V2' : 'V3')
              this.rawData.push(item)
            }
          }
        }

        // 若无模板，则无需弹框
        this.isShowDialog = this.rawData && this.rawData.length > 0
        this.innerVisible = this.isShowDialog
        if (!this.isShowDialog) {
          if (this.callByInstruction) {
            this.$message.warning(lang.t('Message.CorrespondsToThePrintTemplateDoesNotFind') + '！')
          } else {
            this.$message.warning(lang.t('Message.CorrespondsToThePrintTemplateDoesNotFind') + '【' + this.finalCategory + '】！')
          }
          return
        }

        this.toFilterRows()
        this.popSendEmailWindow()
      })
    },
    toFilterRows(actionSource) {
      let rowData = this.rawData
      if (this.isV3Model) {
        if (this.isEmailModel) {
          rowData = rowData.filter(p => (p.engine === 2 || p.engine === 0))
        } else {
          rowData = rowData.filter(p => (p.engine === 2 || p.engine === 0) && p.templateUsage === 0)
        }
      } else {
        if (!this.isEmailModel) {
          rowData = rowData.filter(p => p.templateUsage === 0)
        }
      }
      if (!actionSource && (!rowData || rowData.length === 0)) {
        this.$message.warning(this.$t('Template.notFoundTemplate'))
        return
      }
      if (this.gridApi) {
        this.gridApi.setRowData(rowData)
        this.gridApi.sizeColumnsToFit()
      } else {
        this.rowData = rowData
      }
      this.template = null
    },
    getCreditTemplateSetting(lob) {
      let configName = 'creditBlockPrint'
      if (lob === 'RE' || lob === 'RI') {
        configName += lob
      }
      const setting = String(cache.config.get(configName))
      const d = {}
      const a = setting.split(',')
      for (const o in a) {
        d[o.split('-')[0]] = o.split('-')[1]
      }
      return d
    },
    // 更新提单状态
    // async updateDocCfmStateFunc() {
    //   if (this.template.templateType === 'HBL' ||
    //   this.template.templateType === 'MBL' ||
    //   this.template.templateType === 'HBL2' ||
    //   this.template.templateType === 'MBL2') {
    //     const data = {
    //       name: this.template.name,
    //       uuid: this.finalData.cargoDocUuid
    //     }
    //     const res = await updateDocCfmState(data)
    //     if (res.ok) {
    //       if (res.data) {
    //         this.$emit('updateDocCfmState')
    //       }
    //     }
    //   }
    // },
    async toPrint(previewType) {
      const legacyPrintFlow = await this.isLegacyPrintFlow()
      if (!legacyPrintFlow && this.printLoading) {
        return null
      }
      this.previewType = previewType
      const rows = this.gridApi.getSelectedRows()
      if (rows.length === 0) {
        this.$message.warning(lang.t('Template.PlsSelectTemplate'))
        return
      }
      if (Number(this.template.engine) === 2 && this.selectedLength > this.v3PrintCount && !this.exportType) {
        // this.$message.warning(this.$t('Template.batchPrintMore', [this.v3PrintCount]))
        this.overLimitDialog.visible = true
        return
      }
      // 获取模板详细数据
      await Promise.all([
        getTemplateTypeList({ templateType: this.template.templateType }).then(res => {
          this.templateType = res.data.list.length > 0 ? res.data.list[0] : null
        }),
        getDocumentType(this.template.documentTypeUuid).then(res => {
          this.documentType = res.data ? res.data : null
        })
      ])
      if (!this.templateType || !this.templateType.schemaType) {
        this.$message.warning(this.$t('Template.noSchemaType'))
        return
      }
      let flag = true
      if (this.template.engine === 2 && this.selectedLength > 100 && !this.exportType) {
        // flag = await this.$confirm(this.$t('Template.printMore'), this.$t('Template.Tips'), {
        //   confirmButtonText: lang.t('constant.yes'),
        //   cancelButtonText: lang.t('constant.no'),
        //   type: 'info'
        // }).then(() => true).catch(() => false)
        const promise = new Promise((resolve, reject) => {
          this.over100Dialog.beforeClose = () => {
            this.over100Dialog.visible = false
            reject()
          }
          this.over100Dialog.exportPdf = () => {
            reject()
            this.exportReport('ExportPDF')
            this.over100Dialog.visible = false
          }
          this.over100Dialog.exportExcel = () => {
            reject()
            this.exportReport('ExportXLS')
            this.over100Dialog.visible = false
          }
          this.over100Dialog.exportWord = () => {
            reject()
            this.exportReport('ExportWORD')
            this.over100Dialog.visible = false
          }
          this.over100Dialog.exportPPT = () => {
            reject()
            this.exportReport('ExportPPT')
            this.over100Dialog.visible = false
          }
          this.over100Dialog.continue = () => {
            this.over100Dialog.visible = false
            resolve()
          }
        })
        this.over100Dialog.visible = true
        flag = await promise.then(() => true).catch(() => false)
      }
      if (!flag) return

      if (legacyPrintFlow) {
        const result = await this.printTemplate()
        return await this.afterPrintTemplate(result)
      }

      this.printLoading = true
      this.updatePrintTaskProgress(null)
      try {
        const result = await this.printTemplate()
        return await this.afterPrintTemplate(result)
      } catch (error) {
        this.showPrintTaskError(error)
        return null
      } finally {
        this.printLoading = false
        this.printLoadingText = ''
      }
      // 增加埋点 todo
      // var logStoresParams:Object = {};
      // logStoresParams['templateName'] = template.name;
      // logStoresParams['templateType'] = template.templateType;
      // logStoresParams['printRecordNum'] = selectedLength;
      // var type:String = "";
      // if(template.engine == 0)
      // {
      //   type = "V1";
      // }
      // else if(template.engine == 1)
      // {
      //   type = "V2";
      // }
      // else
      // {
      //   type = "V3";
      // }
      // logStoresParams['function'] =  type + "模板打印";
      // LogStores.sendClickLogStores(logStoresParams,"function",null,null);
    },
    async afterPrintTemplate(result) {
      // `saveExtendMetaDataIfShippingOrder` originally only ran in `exportReport -> handlePrintResult`,
      // so normal/batch "OK" printing would never trigger it.
      // For printing (non-export) flows, attempt to persist extendMetaData when the print API returns a file payload.
      await this.saveExtendMetaDataIfShippingOrder(result)
      // Refresh printing status in background (batch-safe).
      // Backend may be eventually-consistent after saving metadata, so delay a bit before refreshing.
      setTimeout(() => {
        this.refreshPrintStatusSafe(this.getPrintStatusJobUuids())
      }, 1000)

      this.$emit('selectedTemplate', {
        cancelled: false,
        action: 'save',
        template: this.template,
        parameter: this.finalData,
        format: 'PDF',
        isPrintOpr: true,
        isPreCommit: this.isPreCommit,
        previewType: this.previewType
      })
      return result
    },
    async isLegacyPrintFlow() {
      return PrintTaskV2RequestBuilder.isLegacyEnabled(
        getPrintTaskClientModeValue(),
        process.env.VUE_APP_REPORT_PRINT_API_VERSION
      )
    },
    async buildCtxAndDataSe() {
      if (this.template.templateType.trimEnd() === TEMPLATE_TYPE_BOOKING) {
        this.instructionData.ctx = this.job
        PrintTemplateUtil.buildPrintDataByBooking(this.job, this.finalData)
        // 主票 且是 BCF
        // if (!(this.finalCtx.masterFlag && this.finalCtx.containerLoadType !== ContainerLoadType.BC_CARGO_TYPE_FCL.code)) {
        //   // 取 特殊要求的 uuid
        //   if (this.finalCtx.satisfiedRequests) {
        //     if (this.finalCtx.customerId) {
        //       const company = await Company.getCompanyById(this.finalCtx.customerId)
        //       if (company) {
        //         const customer = await Company.loadCustomer(company.uuid).then(data => data.length > 0 ? data[0] : null)
        //         if (customer) {
        //           const allSpecialRequests = await new Customer(customer).getSpecialRequests()
        //           if (allSpecialRequests && allSpecialRequests.length > 0) {
        //             const specialRequests = this.finalCtx.satisfiedRequests.split(',').map(item => item.trim())
        //             const specialRequestUuids = []
        //             for (const item of allSpecialRequests) {
        //               if (item.request && specialRequests.includes(item.request.trim())) {
        //                 specialRequestUuids.push(item.uuid)
        //               }
        //             }
        //             this.finalData.REQUEST_UUID = (specialRequestUuids.length === 0 ? '' : specialRequestUuids)
        //           }
        //         }
        //       }
        //     }
        //   }
        // }
      } else if (this.template.templateType.trimEnd() === TEMPLATE_TYPE_BACNKLETTER) {
        this.instructionData.ctx = this.job
      } else if (this.template.templateType.trimEnd() === TEMPLATE_TYPE_MANIFESTINFO) {
        this.instructionData.ctx = this.job.manifestInfos[0]
        // this.finalData.MANIFEST_INFO_UUID = this.job.manifestInfos[0].uuid
        PrintTemplateUtil.buildPrintDataByManifestInfo(this.job.manifestInfos[0], this.finalData)
      } else if (this.template.templateType.trimEnd() === CargoDocConsts.MBL) {
        this.instructionData.ctx = this.job
        if (this.job.seaCargoDoc && this.job.seaCargoDoc.length > 0) {
          const cargoDoc = this.job.seaCargoDoc.find(p => p.docType === CargoDocConsts.MBL)
          if (cargoDoc) {
            // this.finalData.cargoDocUuid = cargoDoc.uuid
            // this.finalData.DOC_UUID = cargoDoc.uuid
            PrintTemplateUtil.buildPrintDataByMbl(cargoDoc, this.finalData)
          }
        }
      } else if (this.template.templateType.trimEnd() === TEMPLATE_TYPE_LOCALSERVICE) {
        this.instructionData.ctx = this.job
        // this.finalData.USER_ID = this.$store.getters.userId
        PrintTemplateUtil.buildPrintDataByLocalService(this.job, this.finalData)
      } else if (this.template.templateType.trimEnd() === TEMPLATE_TYPE_FBA_INTERNAL_WAREHOUSE) {
        await loadWarehouseInRelated({ jobUuid: this.job.uuid, oversea: false }).then(res => {
          if (res.data && res.data.warehouseIn) {
            // this.finalData.WAREHOUSE_UUID = [res.data.warehouseIn.uuid]
            // this.finalData.USER_ID = this.$store.getters.userId
            PrintTemplateUtil.buildPrintDataByFbaInternalWarehouse(res.data.warehouseIn, this.finalData)
          }
        })
      } else if (this.template.templateType.trimEnd() === TEMPLATE_TYPE_FBA_OVERSEA_WAREHOUSE) {
        await loadWarehouseInRelated({ jobUuid: this.job.uuid, oversea: true }).then(res => {
          if (res.data && res.data.warehouseIn) {
            // this.finalData.WAREHOUSE_UUID = [res.data.warehouseIn.uuid]
            // this.finalData.USER_ID = this.$store.getters.userId
            PrintTemplateUtil.buildPrintDataByFbaOverseaWarehouse(res.data.warehouseIn, this.finalData)
          }
        })
      } else if (this.template.templateType.trimEnd() === TEMPLATE_TYPE_POD_TRUCKING) {
        await getDischargingTruckingList({ jobUuid: this.job.uuid, masterFlag: this.job.masterFlag }).then(res => {
          if (res.data) {
            // const truckingUuids = Array.from(res.data, p => p.uuid).join(',')
            // this.finalData.TRUCKING_UUID = StrUtils.isEmpty(truckingUuids) ? null : truckingUuids
            PrintTemplateUtil.buildPrintDataByPodTrucking(this.job, res.data, this.finalData)
          }
        })
      }
    }, async buildCtxAndDataSi() {
      if (this.template.templateType.trimEnd() === TEMPLATE_TYPE_SIJOBNO) {
        this.instructionData.ctx = this.job
      } else if (this.template.templateType.trimEnd() === TEMPLATE_TYPE_SIMBL) {
        this.instructionData.ctx = this.job
        if (this.job.seaCargoDoc && this.job.seaCargoDoc.length > 0) {
          const cargoDoc = this.job.seaCargoDoc.find(p => p.docType === CargoDocConsts.MBL)
          if (cargoDoc) {
            // this.finalData.cargoDocUuid = cargoDoc.uuid
            // this.finalData.DOC_UUID = cargoDoc.uuid
            PrintTemplateUtil.buildPrintDataBySimbl(cargoDoc, this.finalData)
          }
        }
      } else if (this.template.templateType.trimEnd() === TEMPLATE_TYPE_SIHBL) {
        if (this.job.seaCargoDoc && this.job.seaCargoDoc.length > 0) {
          const cargoDoc = this.job.seaCargoDoc.find(p => p.docType === CargoDocConsts.HBL)
          if (cargoDoc) {
            // this.finalData.cargoDocUuid = cargoDoc.uuid
            // this.finalData.DOC_UUID = cargoDoc.uuid
            // this.finalData.printCallBackUrl = 'services/printExec/sop/update/print_hbl?jobKey=' + encodeURIComponent(this.job.uuid)
            PrintTemplateUtil.buildPrintDataBySihbl(this.job, cargoDoc, this.finalData)
            this.instructionData.ctx = new SeaImCargoDoc(cargoDoc)
            this.instructionData.printedCallback = event => {
              if (event.action === 'print') {
                updateTrackingEvent({ jobUuid: this.job.uuid, eventCode: 'print_hbl' }).then(async res => {
                })
              }
            }
          }
        }
      } else if (this.template.templateType.trimEnd() === TEMPLATE_TYPE_SIPO) {
        await new SeaImportJob(this.job).getPoList()
        if (this.job.poList && this.job.poList.length > 0) {
          // this.finalData.job = this.job.poList[0]
          PrintTemplateUtil.buildPrintDataBySipo(this.job, this.job.poList[0], this.finalData)
        }
      }
    }, async buildCtxAndDataAe() {
      if (this.template.templateType.trimEnd() === TEMPLATE_TYPE_AEBOOKING) {
        this.instructionData.ctx = this.job
      } else if (this.template.templateType.trimEnd() === TEMPLATE_TYPE_BACNKLETTER) {
        this.instructionData.ctx = this.job
      } else if (this.template.templateType.trimEnd() === TEMPLATE_TYPE_AEMAWB) {
        this.instructionData.ctx = this.job
        if (this.job.airCargoDoc && this.job.airCargoDoc.length > 0) {
          const cargoDoc = this.job.airCargoDoc.find(p => p.docType === CargoDocConsts.MAWB)
          if (cargoDoc) {
            // this.finalData.cargoDocUuid = cargoDoc.uuid
            // this.finalData.DOC_UUID = cargoDoc.uuid
            PrintTemplateUtil.buildPrintDataByAemawb(this.job, cargoDoc, this.finalData)
          }
        }
      } else if (this.template.templateType.trimEnd() === TEMPLATE_TYPE_AEHAWB) {
        this.instructionData.ctx = this.job
        if (this.job.airCargoDoc && this.job.airCargoDoc.length > 0) {
          const cargoDoc = this.job.airCargoDoc.find(p => p.docType === CargoDocConsts.HAWB)
          if (cargoDoc) {
            // this.finalData.cargoDocUuid = cargoDoc.uuid
            // this.finalData.DOC_UUID = cargoDoc.uuid
            PrintTemplateUtil.buildPrintDataByAehawb(this.job, cargoDoc, this.finalData)
          }
        }
      } else if (this.template.templateType.trimEnd() === TEMPLATE_TYPE_FBA_INTERNAL_WAREHOUSE) {
        await loadWarehouseInRelated({ jobUuid: this.job.uuid, oversea: false }).then(res => {
          if (res.data && res.data.warehouseIn) {
            // this.finalData.WAREHOUSE_UUID = [res.data.warehouseIn.uuid]
            // this.finalData.USER_ID = this.$store.getters.userId
            PrintTemplateUtil.buildPrintDataByFbaInternalWarehouse(res.data.warehouseIn, this.finalData)
          }
        })
      } else if (this.template.templateType.trimEnd() === TEMPLATE_TYPE_FBA_OVERSEA_WAREHOUSE) {
        await loadWarehouseInRelated({ jobUuid: this.job.uuid, oversea: true }).then(res => {
          if (res.data && res.data.warehouseIn) {
            // this.finalData.WAREHOUSE_UUID = [res.data.warehouseIn.uuid]
            // this.finalData.USER_ID = this.$store.getters.userId
            PrintTemplateUtil.buildPrintDataByFbaOverseaWarehouse(res.data.warehouseIn, this.finalData)
          }
        })
      } else if (this.template.templateType.trimEnd() === TEMPLATE_TYPE_SIPO) {
        await new SeaImportJob(this.job).getPoList()
        if (this.job.poList && this.job.poList.length > 0) {
          this.instructionData.ctx = this.job.poList[0]
        }
      } else if (this.template.templateType.trimEnd() === TEMPLATE_TYPE_LOCALSERVICE) {
        this.instructionData.ctx = this.job
        // this.finalData.USER_ID = this.$store.getters.userId
        PrintTemplateUtil.buildPrintDataByLocalService(this.job, this.finalData)
      } else if (this.template.templateType.trimEnd() === TEMPLATE_TYPE_POD_TRUCKING) {
        await getDischargingTruckingList({ jobUuid: this.job.uuid, masterFlag: this.job.masterFlag }).then(res => {
          if (res.data) {
            // const truckingUuids = Array.from(res.data, p => p.uuid).join(',')
            // this.finalData.TRUCKING_UUID = StrUtils.isEmpty(truckingUuids) ? null : truckingUuids
            PrintTemplateUtil.buildPrintDataByPodTrucking(this.job, res.data, this.finalData)
          }
        })
      }
    }, async buildCtxAndDataAi() {
      if (this.template.templateType.trimEnd() === TEMPLATE_TYPE_AIJOBNO) {
        this.instructionData.ctx = this.job
      } else if (this.template.templateType.trimEnd() === TEMPLATE_TYPE_AIHAWB) {
        this.instructionData.ctx = this.job
        if (this.job.airCargoDoc && this.job.airCargoDoc.length > 0) {
          const cargoDoc = this.job.airCargoDoc.find(p => p.docType === CargoDocConsts.HAWB)
          if (cargoDoc) {
            // this.finalData.cargoDocUuid = cargoDoc.uuid
            // this.finalData.DOC_UUID = cargoDoc.uuid
            PrintTemplateUtil.buildPrintDataByAihawb(this.job, cargoDoc, this.finalData)
          }
        }
      }
    }, async buildCtxAndDataRe() {
      if (this.template.templateType.trimEnd() === TEMPLATE_TYPE_BOOKING_RE) {
        this.instructionData.ctx = this.job
        // if (!this.job.masterFlag) {
        //   // 取 特殊要求的 uuid
        //   if (this.finalCtx.satisfiedRequests) {
        //     if (this.finalCtx.customerId) {
        //       const company = await Company.getCompanyById(this.finalCtx.customerId)
        //       if (company) {
        //         const customer = await Company.loadCustomer(company.uuid).then(data => data.length > 0 ? data[0] : null)
        //         if (customer) {
        //           const allSpecialRequests = await new Customer(customer).getSpecialRequests()
        //           if (allSpecialRequests && allSpecialRequests.length > 0) {
        //             const specialRequests = this.finalCtx.satisfiedRequests.split(',').map(item => item.trim())
        //             const specialRequestUuids = []
        //             for (const item of allSpecialRequests) {
        //               if (item.request && specialRequests.includes(item.request.trim())) {
        //                 specialRequestUuids.push(item.uuid)
        //               }
        //             }
        //             this.finalData.REQUEST_UUID = (specialRequestUuids.length === 0 ? '' : specialRequestUuids)
        //           }
        //         }
        //       }
        //     }
        //   }
        // }
        PrintTemplateUtil.buildPrintDataByBookingRe(this.job, this.finalData)
      } else if (this.template.templateType.trimEnd() === TEMPLATE_TYPE_FBA_INTERNAL_WAREHOUSE) {
        await loadWarehouseInRelated({ jobUuid: this.job.uuid, oversea: false }).then(res => {
          if (res.data && res.data.warehouseIn) {
            // this.finalData.WAREHOUSE_UUID = [res.data.warehouseIn.uuid]
            // this.finalData.USER_ID = this.$store.getters.userId
            PrintTemplateUtil.buildPrintDataByFbaInternalWarehouse(res.data.warehouseIn, this.finalData)
          }
        })
      } else if (this.template.templateType.trimEnd() === TEMPLATE_TYPE_FBA_OVERSEA_WAREHOUSE) {
        await loadWarehouseInRelated({ jobUuid: this.job.uuid, oversea: true }).then(res => {
          if (res.data && res.data.warehouseIn) {
            // this.finalData.WAREHOUSE_UUID = [res.data.warehouseIn.uuid]
            // this.finalData.USER_ID = this.$store.getters.userId
            PrintTemplateUtil.buildPrintDataByFbaOverseaWarehouse(res.data.warehouseIn, this.finalData)
          }
        })
      }
    }, async buildCtxAndDataIe() {
      if (this.template.templateType.trimEnd() === TEMPLATE_TYPE_LOCALSERVICE) {
        this.instructionData.ctx = this.job
        // this.finalData.USER_ID = this.$store.getters.userId
        PrintTemplateUtil.buildPrintDataByLocalService(this.job, this.finalData)
      }
    }, async buildCtxAndData() {
      // 组装 ctx、data
      if (this.jobUuidList && this.jobUuidList.length > 0) {
        // 批量业务模板
        this.finalData.JOB_UUID = this.jobUuidList
        if (this.lob === SE.code) {
          this.instructionData.ctx = new SeaExportJob().fillDefaultValue().getData()
          this.finalData.LOB = this.lob
          this.finalData.printSource = DocumentConstants.BATCH_PRINT_SE.code
          this.finalData.poItemsTabViewModel = cache.config.get('PoItemsTabViewModel')
        } else if (this.lob === SI.code) {
          this.instructionData.ctx = new SeaImportJob().fillDefaultValue().getData()
          this.finalData.LOB = this.lob
          this.finalData.printSource = DocumentConstants.BATCH_PRINT_SI.code
        } else if (this.lob === AE.code) {
          this.instructionData.ctx = new AirExportJob().fillDefaultValue().getData()
          this.finalData.LOB = this.lob
          this.finalData.printSource = DocumentConstants.BATCH_PRINT_AE.code
          this.finalData.jobuuid = this.jobUuidList.join(',')
        } else if (this.lob === AI.code) {
          this.instructionData.ctx = new AirImportJob().fillDefaultValue().getData()
          this.finalData.printSource = DocumentConstants.BATCH_PRINT_AI.code
        } else if (this.lob === RE.code || this.lob === RI.code) {
          this.instructionData.ctx = new RailwayExportJob().fillDefaultValue().getData()
          this.finalData.printSource = DocumentConstants.BATCH_PRINT_RE.code
        } else if (this.lob === IE.code) {
          this.instructionData.ctx = new IntegratedJob().fillDefaultValue().getData()
          this.finalData.printSource = DocumentConstants.BATCH_PRINT_IE.code
        }
      } else {
        // 单个业务模板
        this.instructionData.printedCallback = null
        this.finalData.category = this.template.templateType
        this.finalData.jobuuid = this.job.uuid
        this.finalData.JOB_UUID = this.job.uuid

        // 【海出】
        if (this.lob === SE.code) {
          await this.buildCtxAndDataSe()
        }

        // 【海进】
        else if (this.lob === SI.code) {
          await this.buildCtxAndDataSi()
        }

        // 【空出】
        else if (this.lob === AE.code) {
          await this.buildCtxAndDataAe()
        }

        // 【空进】
        else if (this.lob === AI.code) {
          this.buildCtxAndDataAi()
        }

        // 【铁路】
        else if (this.lob === RE.code || this.lob === RI.code) {
          await this.buildCtxAndDataRe()
        }

        // 【综合物流】
        else if (this.lob === IE.code) {
          this.buildCtxAndDataIe()
        }
      }
    },
    /**
     * 打印选择的模板
     */
    async printTemplate() {
      if (StimulSoftUtil.isOpenStiReport(this.template)) {
        let result = null
        if (this.prePrintCallback != null) {
          const event = {}
          event.cancelled = false
          event.action = PrintUtils.PRINT
          event.template = this.template
          event.documentType = this.documentType
          event.parameter = this.finalData
          event.ctx = this.finalCtx
          event.format = PrintTemplateManager.FORMAT_PDF
          event.isPrintOpr = true
          event.isPreCommit = this.isPreCommit
          event.exportType = this.exportType
          result = await this.prePrintCallback(event)
        } else {
          result = await this.printFileV2()
        }
        if (this.callByInstruction) {
          // 生成指令执行日志
          this.instructionCallback()
        }
        if (this.previewType !== 'preview') {
          this.innerVisible = false
        }
        return result
      } else {
        // 走V1打印或者预览之前，先进行模板验证，判断该模板是否存在
        let isNotExist = false
        await checkTemplateExist(this.template.templateFile).then(res => { isNotExist = res.data })
        if (!isNotExist) {
          if (this.finalData.showPreview) {
            await this.showPreviewHandler()
          } else {
            await this.printFileV1()
          }
          if (this.callByInstruction) {
            // 生成指令执行日志
            this.instructionCallback()
          }
        } else {
          this.$message.warning(this.$t('Template.notFoundTemplateFromData', [this.template.templateFile]))
        }
        if (!this.callByInstruction) {
          this.innerVisible = false
        }
      }
    },
    instructionCallback() {
      // 生成指令执行日志
      if (this.jobUuidList && this.jobUuidList.length > 0) {
        this.$emit('instructionCallback', { jobUuids: this.jobUuidList, executeStatus: true })
      } else {
        this.$emit('instructionCallback', { jobUuids: [this.job.uuid], executeStatus: true })
      }
    },
    async printFileV1(action = null, format = null) {
      this.action = action
      this.format = format
      // 启用模板名称自定义功能
      await this.getCommonTemplateName()
      // 未启用模板自定义名称功能则默认为原有模板规则
      // 打印方法
      await this.loadSuccessHandlerV1()
    },
    // v1模板打印抽取
    async loadSuccessHandlerV1() {
      const event = {}
      event.cancelled = false
      event.action = this.action ? this.action : PrintUtils.PRINT
      event.template = this.template
      event.documentType = this.documentType
      event.parameter = this.finalData
      event.format = this.format ? this.format : PrintTemplateManager.FORMAT_PDF
      event.isPrintOpr = true
      event.isPreCommit = this.isPreCommit
      event.ctx = this.finalCtx
      this.$logger.log('loadSuccessHandlerV1==参数==', event)
      if (this.prePrintCallback != null && (Object.prototype.hasOwnProperty.call(this.finalData, 'fileAliasName') || PrintUtils.isExecutor(event.action))) {
        await this.prePrintCallback(event)
      } else {
        await this.doPrint(this.template, this.documentType, event.format, this.finalData, event.action === PrintUtils.PRINT, false)
      }

      // this.$logger.log('loadSuccessHandlerV1==this.finalPrintedCallback==', this.finalPrintedCallback)
      if (this.finalPrintedCallback != null) {
        await this.finalPrintedCallback(event)
        this.$logger.log('loadSuccessHandlerV1==event.action==', event.action)
        if (PrintUtils.isExecutor(event.action)) {
          await PrintUtils.printChangeSop(this.template, this.documentType, this.finalCtx)// v1触发sop ctx是传入的实体,后续使用job需要单独处理
        }
      }
    },
    // V1预览
    showPreviewHandler() {
      this.cargoTemplatePreview.fetchSize = 3
      this.cargoTemplatePreview.template = this.template
      this.cargoTemplatePreview.parameters = this.finalData
      this.cargoTemplatePreview.entity = this.finalCtx
      this.cargoTemplatePreview.visible = true
    },
    printTempFileEventHandler(evt) {
      this.printFileV1(evt ? evt.action : null, evt ? evt.format : null)
    },
    async sendEmailTriggerEventHandler(printEvent = null) {
      if (printEvent) {
        this.template = Object.prototype.hasOwnProperty.call(printEvent, 'template') ? printEvent.template : this.template
        if (this.callByInstruction) {
          this.instructionData.data = Object.prototype.hasOwnProperty.call(printEvent, 'parameter') ? printEvent.parameter : this.instructionData.data
          this.instructionData.ctx = Object.prototype.hasOwnProperty.call(printEvent, 'ctx') ? printEvent.ctx : this.instructionData.ctx
        } else {
          this.data = Object.prototype.hasOwnProperty.call(printEvent, 'parameter') ? printEvent.parameter : this.data
          this.ctx = Object.prototype.hasOwnProperty.call(printEvent, 'ctx') ? printEvent.ctx : this.ctx
        }
        this.documentType = Object.prototype.hasOwnProperty.call(printEvent, 'documentType') ? printEvent.documentType : this.documentType
      }
      if (!this.documentType && this.template && this.template.documentTypeUuid) {
        await getDocumentType(this.template.documentTypeUuid).then(res => {
          this.documentType = res.data ? res.data : null
        })
      }
      await this.doPrint(this.template, this.documentType, PrintTemplateManager.FORMAT_PDF, this.finalData, true, true)
    },
    async doPrint(template, documentType, format, parameters, inline = true, isExecuteV1 = true) {
      const url = await PrintTemplateManager.print(template, documentType, format, parameters, inline)
      if (url) {
        await this.loadMailURL(url, isExecuteV1)
      }
    },
    /**
     * 加载MailURLRequest
     */
    async loadMailURL(urlRequest, isExecuteV1) {
      let status = -1
      const request = new XMLHttpRequest()
      request.open('GET', urlRequest, false) // false 同步，默认异步【此处需要同步，需要拿status判断做后续处理】
      request.onload = function(e) {
        status = e.target.status
      }
      request.onerror = function(e) {
        this.loadError()
      }
      request.send()
      //
      if (status === 200) {
        // 这段逻辑不能删除，预览发邮件按钮时执行，对应老系统【sendEmailTriggerEventHandler】
        if (this.finalPrintedCallback && isExecuteV1) {
          const event = {}
          event.action = PrintUtils.EMAIL
          event.parameter = this.finalData
          event.ctx = this.finalCtx
          event.template = this.template
          event.documentType = this.documentType
          this.finalPrintedCallback(event)
        }
      }
      if (this.finalData.showPreview) {
        this.httpResultEmail(status)
      } else {
        this.profitSubmitHandler(status)
      }
    },
    /**
     * Mail异常结果处理
     */
    httpResultEmail(status) {
      // 附件过大
      if (status === 0) {
        this.$message.warning(this.$t('Template.attachmentLarge'))
      } else if (status === 1) {
        this.$message.warning(this.$t('Template.smtpServerError'))
      } else if (status === 2) {
        this.$message.warning(this.$t('Template.unConnectSmtp'))
      } else if (status === 3) {
        this.$message.warning(this.$t('Template.notFoundFile'))
      } else if (status === 4) {
        this.$message.warning(this.$t('Template.fileSendError'))
      } else if (status === 5) {
        this.$message.warning(this.$t('Template.attachmentTemplateError'))
      } else if (status === 200) {
        this.$message.success(this.$t('Template.sendEmailSuccess'))
      }
    },
    /**
     * @private
     */
    profitSubmitHandler(status) {
      if (Number(status) === 200 && this.commitFlag) {
        // Alert.show("业务提交成功","提示!"); 【老系统就是屏蔽了的】
      }
    },
    // sop节点更新
    sopTriggerEventHandler(evt) {
      this.$logger.log('sopTriggerEventHandler==this.ctx==' + this.finalCtx instanceof Job, this.finalCtx)
      this.$logger.log('sopTriggerEventHandler==this.template==', this.template)
      this.$logger.log('sopTriggerEventHandler==this.documentType==', this.documentType)
      if (this.finalCtx && this.template && this.documentType) {
        let jobUuid = ''
        if (this.finalCtx instanceof Job || this.finalCtx instanceof SeaExportJob) {
          jobUuid = this.finalCtx.uuid
        } else if (this.finalCtx instanceof SeaCargoDoc) {
          jobUuid = this.finalCtx.getData().jobUuid
        }
        if (jobUuid) {
          const objParams = { jobUuid: jobUuid, docKeys: this.documentType.uuid }
          updateTrackingForDocumentType(objParams)
        }
      }
    },
    // V2打印
    async printFileV2(printEvent = null) {
      if (printEvent) {
        this.template = Object.prototype.hasOwnProperty.call(printEvent, 'template') ? printEvent.template : this.template
        if (this.callByInstruction) {
          this.instructionData.data = Object.prototype.hasOwnProperty.call(printEvent, 'parameter') ? printEvent.parameter : this.instructionData.data
          this.instructionData.ctx = Object.prototype.hasOwnProperty.call(printEvent, 'ctx') ? printEvent.ctx : this.instructionData.ctx
        } else {
          this.data = Object.prototype.hasOwnProperty.call(printEvent, 'parameter') ? printEvent.parameter : this.data
          this.ctx = Object.prototype.hasOwnProperty.call(printEvent, 'ctx') ? printEvent.ctx : this.ctx
        }
        this.documentType = Object.prototype.hasOwnProperty.call(printEvent, 'documentType') ? printEvent.documentType : this.documentType
      }

      // 启用模板名称自定义功能
      await this.getCommonTemplateName()
      // 打印方法
      // 未启用模板自定义名称功能则默认为原有模板规则
      return await this.loadSuccessHandlerV2()
    },
    // 自定义模板名称
    async getCommonTemplateName() {
      // 启用模板名称自定义功能
      if (parseInt(cache.config.get('templateNameRuleButton')) === 1) {
        const templateEntityUuid = this.templateNameParams()
        const item = {}
        item.anyStr = templateEntityUuid // UUID
        item.anyStr1 = this.finalData.jobuuid || templateEntityUuid || '' // jobUuid
        item.anyStr2 = this.template.uuid // documentTypeUuid
        item.anyStr3 = this.finalCategory // category
        item.anyStr4 = this.template.name // templateName
        if (this.finalCategory === 'TRUCKING') {
          item.anyStr5 = this.finalData.TRUCKING_UUID // 当前门点的UUID
          item.anyInteger1 = this.finalData.TRUCKING_TYPE // 当前门点的类型，区分客户门点还是目的地派送
        }
        item.anyInteger = parseInt(cache.config.get('templateNameRuleButton')) // templateNameRuleButton
        await getTemplateName(item).then(res => {
          // V2模板自定义名称规则回调函数
          const result = res.data
          this.finalData.templateSeparators = result.separators
          if (result.hasOwnProperty('templateRuleName') && result.templateRuleName) {
            this.finalData.templateRuleName = decodeURIComponent(result.templateRuleName)
          } else {
            this.finalData.templateRuleName = ''
          }
        })
      }
    },
    async loadSuccessHandlerV2() {
      this.finalData['email_to'] = this.email_to
      this.finalData['email_cc'] = this.email_cc
      this.finalData['email_title'] = this.email_title
      this.finalData['email_content'] = this.email_content
      this.finalData.designMode = this.designMode
      this.finalData.documentType = this.documentType
      const result = await StimulSoftUtil.stiReportPreview(
        this.template,
        this.finalCtx,
        this.finalData,
        1,
        this.exportType,
        { onProgress: task => this.updatePrintTaskProgress(task) }
      )
      this.$logger.log('this.v2CheckCallback', this.v2CheckCallback)
      if (this.v2CheckCallback != null) {
        setTimeout(() => {
          this.v2PrintConfirm(true)
          this.innerVisible = false
        }, 1000)
      }
      return result
    },
    v2PrintConfirm(isYes) {
      const evt = {}
      evt.action = PrintUtils.PRINT
      evt.isPrintOpr = true
      evt.isPreCommit = this.isPreCommit
      evt.template = this.template
      this.finalData.event = evt
      if (this.v2CheckCallback) {
        this.v2CheckCallback(isYes, this.template, this.finalCtx, this.finalData)
      }
    },
    showCopyDialog() {
      const rows = this.gridApi.getSelectedRows()
      if (rows.length === 0) {
        this.$message.warning(lang.t('common.tips.hasOneAtleast'))
        return
      }
      this.copyDialog.name = this.template.name
      this.copyDialog.visible = true
    },
    save() {
      if (!this.copyDialog.name) {
        this.$message.warning(this.$t('Template.notEmptyTemplateName'))
        return
      }
      for (const item of this.rawData) {
        if (item.templateType === this.template.templateType && item.name === this.copyDialog.name) {
          this.$message.warning(this.$t('Template.hasFoundTemplateName'))
          return
        }
      }
      saveTemplate({
        documentId: this.template.documentId,
        enable: false,
        templateFile: this.template.templateFile,
        engine: this.template.engine,
        filter: this.template.filter,
        name: this.copyDialog.name,
        remarks: this.copyDialog.name,
        officeId: this.template.officeId,
        templateType: this.template.templateType,
        templateUsage: 0
      }).then(res => {
        this.$message.success(this.$t('Message.SaveSuccessfully'))
        this.initData()
      }).finally(() => {
        this.copyDialog.visible = false
      })
    },
    /**
     * 模板前端参数分装公共方法提取
     */
    templateNameParams() {
      const batchJobListTypes = ['JOBLIST', 'SALETYPE', 'SIJOBLIST', 'AEJOBLIST', 'AIJOBLIST', 'JOBLIST_RE', 'IEJOBLIST']
      if (batchJobListTypes.includes(this.finalCategory)) {
        const jobUuid = this.finalData.JOB_UUID
        return isString(jobUuid) ? jobUuid : (Array.isArray(jobUuid) && jobUuid.length > 0 ? jobUuid[0] : '')
      }
      if (this.finalCategory === 'HBL2ZB' || this.finalCategory === 'HBL2DF' || this.finalCategory === 'MBL2' || this.finalCategory === 'HBL2' ||
      this.finalCategory === 'SIMBL' || this.finalCategory === 'SIMBL2' || this.finalCategory === 'SIHBL' || this.finalCategory === 'SIHBLZB' ||
      this.finalCategory === 'SIHBLDF' || this.finalCategory === 'SIHBL2ZB' || this.finalCategory === 'SIHBL2DF' || this.finalCategory === 'AEMAWB' ||
        this.finalCategory === 'AEHAWB' || this.finalCategory === 'AEHAWB2' || this.finalCategory === 'AIHAWB' || this.finalCategory === 'HAWB2') { // 正本或电放 拆并单
        return this.finalData.cargoDocUuid
      } else if (this.finalCategory === 'INTERNALBILLING') { // 账单
        if (isString(this.finalData.BILLING_UUID)) {
          return this.finalData.BILLING_UUID
        } else {
          return this.finalData.BILLING_UUID[0]
        }
      } else if (this.finalCategory === 'BILLPAYMENT') { // 付款申请
        if (isString(this.finalData.BILLPAYMENT_UUID)) {
          return this.finalData.BILLPAYMENT_UUID
        } else {
          return this.finalData.BILLPAYMENT_UUID[0]
        }
      } else if (this.finalCategory === 'INVOICE') { // 发票
        if (isString(this.finalData.INVOICE_UUID)) {
          return this.finalData.INVOICE_UUID
        } else {
          return this.finalData.INVOICE_UUID[0]
        }
      } else if (this.finalCategory === 'BILLING') { // 海出的国外账单页签&账单模块的国外账单
        if (isString(this.finalData.BILLING_UUID)) {
          return this.finalData.BILLING_UUID
        } else {
          return this.finalData.BILLING_UUID[0]
        }
      } else if (this.finalCategory === 'AEBILLING' || this.finalCategory === 'DEBITNOTE_AI') { // 空运出口的国外账单
        if (isString(this.finalData.BILLING_UUID)) {
          return this.finalData.BILLING_UUID
        } else {
          return this.finalData.BILLING_UUID[0]
        }
      } else if (this.finalCategory === 'DEBITNOTE_SI') { // 海运进口国外账单
        if (isString(this.finalData.BILLING_UUID)) {
          return this.finalData.BILLING_UUID
        } else {
          return this.finalData.BILLING_UUID[0]
        }
      } else if (this.finalCategory === 'GROUPBILLING') { // 对账单
        if (isString(this.finalData.BILLING_UUID)) {
          return this.finalData.BILLING_UUID
        } else {
          return this.finalData.BILLING_UUID[0]
        }
      } else if (this.finalCategory === 'VGM') { // VGM
        if (isString(this.finalData.VGM_UUID)) {
          return this.finalData.VGM_UUID
        } else {
          return ''
        }
      } else if (this.finalCategory === 'LCL') {
        return this.finalData.CONTAINER_UUID
      } else if (this.finalCategory === 'HBL') {
        return this.finalData.cargoDocUuid
      }
      return ''
    },
    /**
     * 发送邮件
     */
    async popSendEmailWindow() {
      this.email_to = ''
      this.email_cc = ''
      this.email_title = ''
      this.email_content = ''
      if (this.enableEmailAddressByReceiver && this.finalCtx != null) {
        this.sendEmailDialog.emailTitle = ''
        await this.$refs['sendEmailDialog'].reloadDefaultEmailChange()
        this.sendEmailDialog.visible = true
      }
    },
    sendCallBackEvent(to, cc, title, content) {
      this.email_to = to
      this.email_cc = cc
      this.email_title = title
      this.email_content = content
    },
    close() {
      this.handleResetFilter()
      this.isShowDialog = false
      this.innerVisible = false
    },
    handleFilter: lodash.debounce(function(e) {
      this.gridOptions.api.setQuickFilter(e)
    }, 250, { leading: false, trailing: true }),
    handleResetFilter() {
      this.filterText = ''
      this.gridOptions.api.setQuickFilter('')
    },
    getPrintStatusJobUuids() {
      return (this.jobUuidList && this.jobUuidList.length > 0)
        ? this.jobUuidList
        : [(this.job && this.job.uuid) || (this.finalCtx && this.finalCtx.uuid) || '']
    },
    async refreshPrintStatusSafe(jobUuids) {
      const list = Array.isArray(jobUuids) ? jobUuids : [jobUuids]
      const uniq = [...new Set(list.filter(p => !StrUtils.isEmpty(p)))]
      // Avoid spamming the backend when batch printing.
      const chunkSize = 10
      for (let i = 0; i < uniq.length; i += chunkSize) {
        const chunk = uniq.slice(i, i + chunkSize)
        await Promise.all(chunk.map(jobUuid => refreshPrintStatus(jobUuid).catch(() => {})))
      }
    },
    async returnMainEventHandler(data) {
      if (this.returnMainCallback) {
        await this.returnMainCallback(data)
      }
    },
    async saveExtendMetaDataIfShippingOrder(res) {
      const file = res && res.data ? res.data : null
      const fileId = file ? (file.id || file.fileId || '') : ''
      const extendMetaData = file && file.extendMetaData ? file.extendMetaData : null
      if (!fileId || !extendMetaData) {
        return
      }
      const xmlEscape = (val) => {
        if (val === null || val === undefined) return ''
        return String(val)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/\"/g, '&quot;')
          .replace(/'/g, '&apos;')
      }
      let entries = ''
      for (const key of Object.keys(extendMetaData)) {
        const rawVal = extendMetaData[key]
        const value = (rawVal && typeof rawVal === 'object') ? JSON.stringify(rawVal) : rawVal
        entries += `<entry><key>${xmlEscape(key)}</key><value>${xmlEscape(value)}</value></entry>`
      }
      const xmlParam = `<RequestObject><fileId>${xmlEscape(fileId)}</fileId><extendMetaData>${entries}</extendMetaData></RequestObject>`
      await saveMetaData(xmlParam).catch(() => {})
    },
    async exportReport(exportType) {
      if (await this.isLegacyPrintFlow()) {
        const loading = getLoading4Cxt(this)
        try {
          const res = await this.toPrint(exportType)
          await this.handlePrintResult(res)
        } finally {
          loading.close()
        }
        return
      }

      try {
        const res = await this.toPrint(exportType)
        await this.handlePrintResult(res)
      } catch (error) {
        this.showPrintTaskError(error)
      }
    },
    updatePrintTaskProgress(task) {
      if (!task) {
        this.printLoadingText = this.$t('Message.PrintTaskProcessing')
        return
      }
      if (task.status === 'SUCCEEDED') {
        this.printLoadingText = this.$t('Message.PrintTaskDownloading')
        return
      }
      const finished = Number(task.finishedUnits || 0)
      const total = Number(task.totalUnits || 0)
      if (total > 0) {
        this.printLoadingText = this.$t('Message.PrintTaskProcessingProgress', [finished, total])
      } else {
        this.printLoadingText = this.$t('Message.PrintTaskProcessing')
      }
    },
    showPrintTaskError(error) {
      const printTask = error && error.printTask
      const detail = this.getPrintTaskErrorDetail(printTask, error)
      this.$message.error(this.$t('Message.PrintTaskFailed', [detail]))
      const taskSnapshot = JSON.stringify(printTask)
      this.$logger.error('V2打印任务失败明细：' + taskSnapshot)
      console.warn('V2打印任务失败明细：' + taskSnapshot)
    },
    getPrintTaskErrorDetail(printTask, error) {
      const base = (printTask && printTask.errorMsg) ||
        (error && error.message) || this.$t('Message.Error')
      const failedItems = (printTask && Array.isArray(printTask.items) ? printTask.items : [])
        .filter(item => item.errorMsg || item.state === 'FAILED')
      const details = failedItems.slice(0, 5).map(item => {
        const target = item.businessUuid || item.unitId || this.$t('Message.PrintTaskUnknownUnit')
        return `${target}: ${item.errorMsg || item.state || 'FAILED'}`
      })
      if (failedItems.length > details.length) {
        details.push(`...${failedItems.length - details.length}`)
      }
      const printId = printTask && printTask.printId ? `printId=${printTask.printId}` : ''
      return [printId, base, ...details].filter(Boolean).join('；')
    },
    // 处理打印结果
    async handlePrintResult(res) {
      if (!res) {
        return
      }
      if (res.printTask && res.downloaded) {
        return
      }
      if (res.data) {
        const storageURL = cache.config.get('StorageURL')
        const url = `${storageURL}file/open/${res.data.id}?sessionId=${this.user.sessionId}`
        window.open(url)
      } else {
        const htmlMsg = `
            <div style="text-align: center;line-height: 35px;">
              <div style="font-size: 16px;font-weight: bold;">${this.$t('Message.ExportingPleaseWait')}</div>
              <div style="font-size: 14px;">${this.$t('Message.ExportTakePlaceInBackground')}</div>
              <div style="font-size: 14px;">
                ${this.$t('Message.CompletionDownloadMessageReminderInRightCorner', ['<svg style="width: 1em;height: 1em;font-size: 16px;"><use xlink:href="#icon-top_message"></use></svg>'])}
              </div>
            </div>`
        this.$alert(htmlMsg, this.$t('Message.Prompt'), {
          dangerouslyUseHTMLString: true
        })
      }
    }
  }
}
</script>

<style>
</style>
